<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <div v-if="tabs.length > 1">
      <v-tabs v-model="activeTab" grow>
        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <div v-if="activeTab && activeTab === $route.path && activeTab === tab.route" >
            <router-view />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'RestaurantReports',
  data () {
    return {
      activeTab: null
    }
  },
  computed: {
    permissions () {
      return this.$store.state.login.permissions
    },
    tabs () {
      return [
        { tabMenu: 'reports.tabs.salesAndCosts', name: 'SalesAndCosts', route: '/reports/sales-and-costs' },
        { tabMenu: 'reports.tabs.purchasesTracking', name: 'PurchasesTracking', route: '/reports/purchases-tracking' },
        { tabMenu: 'reports.tabs.recipesTracking', name: 'RecipesTracking', route: '/reports/recipes-tracking' },
        { tabMenu: 'reports.tabs.priceComparison', name: 'PriceComparison', route: '/reports/price-comparison' },
        { tabMenu: 'reports.tabs.providerPriceComparison', name: 'ProviderPriceComparison', route: '/reports/provider-price-comparison' },
        { tabMenu: 'reports.tabs.consumption', name: 'Consumption', route: '/reports/consumption' }
      ]
    }
  }
}
</script>
